/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Actions_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Preset Actions" |
*
* @param {Styles_Preset_Actions_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_actions_aria_label = /** @type {((inputs?: Styles_Preset_Actions_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Actions_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions de preset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreingestellte Aktionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni preimpostate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно заданные действия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones preestablecidas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットアクション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्व निर्धारित क्रियाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações predefinidas")
	return /** @type {LocalizedString} */ ("Preset Actions")
});